import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import CtaSection from "@/components/CtaSection";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/site";

export default function Faq() {
    return (
        <div>
            <Seo
                title="FAQ | The Sens Civil Works Consultancy — Gorakhpur"
                description="Common questions about independent civil engineering consultancy, site inspection, BOQ review and contractor bill checking in Gorakhpur, UP."
            />
            <PageHero
                overline="FAQ"
                title="Frequently Asked Questions"
                description="Straightforward answers about scope, process and what an independent review does — and does not — cover."
            />
            <section className="bg-white py-20 lg:py-28" data-testid="faq-section">
                <div className="mx-auto max-w-4xl px-6 lg:px-12">
                    <Reveal>
                        <Accordion type="single" collapsible className="border-t border-slate-200" data-testid="faq-accordion">
                            {FAQS.map((f, i) => (
                                <AccordionItem
                                    key={f.question}
                                    value={`faq-${i}`}
                                    className="border-b border-slate-200"
                                    data-testid={`faq-item-${i}`}
                                >
                                    <AccordionTrigger
                                        className="py-6 text-left font-display text-lg font-bold text-navy hover:text-amber hover:no-underline"
                                        data-testid={`faq-question-${i}`}
                                    >
                                        {f.question}
                                    </AccordionTrigger>
                                    <AccordionContent
                                        className="pb-6 text-base leading-relaxed text-slate-600"
                                        data-testid={`faq-answer-${i}`}
                                    >
                                        {f.answer}
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </Reveal>
                </div>
            </section>
            <CtaSection
                overline="Still Have a Question?"
                title="Ask Us Directly"
                description="Every project is different. A short conversation is the fastest way to get a specific answer."
            />
        </div>
    );
}
